import { Rs } from '../components'

export const Header = ({
	title,
	bg = '/img/00-header.png',
	opts = 'q:50/w:1280',
}) => {
	return <header style={`background:url(${Rs(bg, opts)}) bottom`}><h2 class="ptsn">{title}</h2></header>
}
